import React, { memo } from "react";

import { useSessionContext } from "@/contexts/SessionContext";
import { ScheduleManage } from "@/pages/schedulemanager/ScheduleManage";
import { ScheduleViewer } from "@/pages/scheduleviewer/ScheduleViewer";

/**
 * Rota unificada para "/schedule".
 *
 * Motivo:
 * - No legado existiam DUAS páginas com o mesmo path (profissional e paciente),
 *   o que causava colisão no pageRegistry e itens de menu sumindo.
 *
 * Regra:
 * - professional → ScheduleManage
 * - patient      → ScheduleViewer
 */
const ScheduleRoute = memo(() => {
  const { access } = useSessionContext();

  if (access?.type === "patient") {
    return <ScheduleViewer />;
  }

  return <ScheduleManage />;
});

ScheduleRoute.displayName = "ScheduleRoute";

export default ScheduleRoute;

